var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoresLogo5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#F1F4F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.833 38.5851H32V78H55.833V38.5851Z",
    fill: "#D7513E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4736 29.4214H37.6406V25.5071C37.6406 23.5688 39.2094 22 41.1477 22H57.9666C59.9049 22 61.4736 23.5688 61.4736 25.5071V29.4214Z",
    fill: "#2B5B4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.833 38.5851H32L37.6339 29.4214H61.4745L55.833 38.5851Z",
    fill: "#FAE7DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1114 38.5851V78H55.8359V38.5851L61.4775 29.4214L67.1114 38.5851Z",
    fill: "#2B5B4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5259 47.1604H37.3045C36.8219 47.1604 36.4297 46.7682 36.4297 46.2855C36.4297 45.8028 36.8219 45.4106 37.3045 45.4106H50.5259C51.0085 45.4106 51.4007 45.8028 51.4007 46.2855C51.4007 46.7758 51.0085 47.1604 50.5259 47.1604Z",
    fill: "#C94536"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5259 53.4203H37.3045C36.8219 53.4203 36.4297 53.0281 36.4297 52.5454C36.4297 52.0628 36.8219 51.6706 37.3045 51.6706H50.5259C51.0085 51.6706 51.4007 52.0628 51.4007 52.5454C51.4007 53.0281 51.0085 53.4203 50.5259 53.4203Z",
    fill: "#C94536"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5259 59.6727H37.3045C36.8219 59.6727 36.4297 59.2805 36.4297 58.7979C36.4297 58.3152 36.8219 57.923 37.3045 57.923H50.5259C51.0085 57.923 51.4007 58.3152 51.4007 58.7979C51.4007 59.2805 51.0085 59.6727 50.5259 59.6727Z",
    fill: "#C94536"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoresLogo5);
export default __webpack_public_path__ + "static/media/stores-logo-5.69304bfd0dabe94ad0c83d7205e0e803.svg";
export { ForwardRef as ReactComponent };